/*
 * @Description:
 * @Author: 姓名
 * @Date: 2026-03-30 10:17:48
 * @LastEditTime: 2026-03-30 11:05:51
 * @LastEditors: caoran
 */
/**
 * My Space 路由注册中心
 *
 * 每次新建页面，只需在这里加两行：
 *   1. import YourPage from './your-feature'
 *   2. 在 Switch 里加一行：<Route path="/my-space/your-feature" component={YourPage} />
 *
 * App.js 已经统一注册了 <Route path="/my-space" component={MySpaceRoutes} />
 * 之后不需要再动 App.js。
 */

import React from 'react'
import { Routes, Route } from 'react-router-dom'

// ↓↓↓ 在这里 import 你的页面组件 ↓↓↓
import PersonalSpace from './personal-space'

const MySpaceRoutes: React.FC = () => (
  <Routes>
    {/* ↓↓↓ 在这里注册你的路由 ↓↓↓ */}
    <Route path="personal-space" element={<PersonalSpace />} />
  </Routes>
)

export default MySpaceRoutes
